export default __webpack_public_path__ + "static/media/modulefuture.efa16c9c.gif";